export const WIDTH_DESKTOP_WIDE = '1405';  // 1242
